import React from 'react';

import withLayout from '../../hoc/with-layout';
import { DocumentsView } from './documents-view-page';

const DocumentScreen: React.FC = () => {
  return <DocumentsView />;
};
export default withLayout(DocumentScreen);
